import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    event.stopPropagation()
    const panel = this.panelTarget
    if (panel.style.display === "none" || !panel.style.display) {
      panel.style.display = "block"
    } else {
      panel.style.display = "none"
    }
  }

  connect() {
    this.handleOutsideClick = (e) => {
      if (!this.element.contains(e.target)) {
        this.panelTarget.style.display = "none"
      }
    }
    document.addEventListener("click", this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick)
  }
}
